export default __webpack_public_path__ + "static/media/Recruitment.597138fd.png";